<template>
  <div class="mt-5 flex justify-center">
    <iframe
      class="w-full h-screen bg-gray-100"
      src="https://juanabapl.juanabonita.com.co:446/ApireportsecommerceH/reports/informeInventarios.aspx"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "InformeDisponible",
  data() {
    return {
      user: "",
    };
  },
};
</script>

<style>
</style>


//  :src="
//                'https://localhost:44384/Reports/' +
//                  report.nombre +
//                  '.aspx?reportname=' +
//                  report.nombre"